// extracted by mini-css-extract-plugin
export default {"PrimerLink":"DirectoryRow-module__PrimerLink--MeWOM","Box":"DirectoryRow-module__Box--uM44V","Octicon":"DirectoryRow-module__Octicon--_lwmM"};